package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SyncW500Rounded: ImageVector
    get() {
        if (_syncW500Rounded != null) {
            return _syncW500Rounded!!
        }
        _syncW500Rounded = Builder(name = "SyncW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(245.02f, 482.0f)
                quadToRelative(0.0f, 43.57f, 16.64f, 84.99f)
                quadToRelative(16.64f, 41.42f, 51.69f, 76.94f)
                lineToRelative(8.08f, 8.09f)
                verticalLineToRelative(-50.35f)
                quadToRelative(0.0f, -17.71f, 12.1f, -29.69f)
                reflectiveQuadTo(363.35f, 560.0f)
                quadToRelative(17.72f, 0.0f, 29.69f, 11.98f)
                quadToRelative(11.98f, 11.98f, 11.98f, 29.69f)
                verticalLineToRelative(157.61f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(202.15f, 804.78f)
                quadToRelative(-17.72f, 0.0f, -29.69f, -12.1f)
                quadToRelative(-11.98f, -12.09f, -11.98f, -29.81f)
                reflectiveQuadToRelative(12.1f, -29.7f)
                quadToRelative(12.09f, -11.97f, 29.81f, -11.97f)
                horizontalLineToRelative(60.2f)
                lineToRelative(-12.89f, -11.61f)
                quadToRelative(-52.24f, -47.44f, -73.96f, -107.16f)
                quadToRelative(-21.72f, -59.71f, -21.72f, -120.43f)
                quadToRelative(0.0f, -96.39f, 50.03f, -174.92f)
                quadToRelative(50.04f, -78.54f, 133.91f, -119.78f)
                quadToRelative(15.67f, -8.47f, 32.25f, 0.08f)
                quadToRelative(16.57f, 8.55f, 22.05f, 26.71f)
                quadToRelative(5.24f, 17.15f, -1.34f, 33.94f)
                quadToRelative(-6.57f, 16.8f, -22.49f, 25.75f)
                quadToRelative(-56.32f, 31.29f, -89.86f, 86.59f)
                quadToRelative(-33.55f, 55.3f, -33.55f, 121.63f)
                close()
                moveTo(714.98f, 478.0f)
                quadToRelative(0.0f, -43.57f, -16.64f, -84.99f)
                quadToRelative(-16.64f, -41.42f, -51.69f, -76.94f)
                lineToRelative(-8.08f, -8.09f)
                verticalLineToRelative(50.35f)
                quadToRelative(0.0f, 17.71f, -11.98f, 29.69f)
                reflectiveQuadTo(596.89f, 400.0f)
                quadToRelative(-17.72f, 0.0f, -29.81f, -12.1f)
                quadToRelative(-12.1f, -12.1f, -12.1f, -29.81f)
                verticalLineToRelative(-157.37f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(157.37f)
                quadToRelative(17.72f, 0.0f, 29.69f, 11.98f)
                quadToRelative(11.98f, 11.97f, 11.98f, 29.69f)
                reflectiveQuadToRelative(-11.98f, 29.82f)
                quadToRelative(-11.97f, 12.09f, -29.69f, 12.09f)
                horizontalLineToRelative(-60.44f)
                lineToRelative(12.89f, 11.61f)
                quadToRelative(49.72f, 49.96f, 72.7f, 108.42f)
                quadToRelative(22.98f, 58.45f, 22.98f, 119.17f)
                quadToRelative(0.0f, 96.39f, -50.03f, 174.92f)
                quadToRelative(-50.04f, 78.54f, -133.91f, 119.78f)
                quadToRelative(-15.67f, 8.47f, -32.25f, -0.08f)
                quadToRelative(-16.57f, -8.55f, -22.05f, -26.71f)
                quadToRelative(-5.24f, -17.15f, 1.34f, -33.94f)
                quadToRelative(6.57f, -16.8f, 22.49f, -25.75f)
                quadToRelative(56.32f, -31.29f, 89.86f, -86.59f)
                quadToRelative(33.55f, -55.3f, 33.55f, -121.63f)
                close()
            }
        }
        .build()
        return _syncW500Rounded!!
    }

private var _syncW500Rounded: ImageVector? = null
